import { useSelector } from 'react-redux';
import NavigateLink from '../navigateLink/navigateLink';
import classes from './BannerItem.module.css'

const BannerItem = ({ banner, dropClass, height, width, className }) => {

    const { lang } = useSelector(state => state.translate)

    return (
        banner?.color ?
            <NavigateLink link={banner?.link}>
                <div className={`${classes.Banner} ${className}` } style={{ backgroundColor: banner.color, height }}>
                    <p className={classes.Text} style={{ color: banner?.colorText }}>{banner?.text?.[lang] ?? ""}</p>
                    <img className={`${dropClass} ${classes.Img} `} style={{ width: banner?.imgWidth }} src={banner.img} alt="" />
                </div >
            </NavigateLink>
            :
            <NavigateLink link={banner?.link}>
                <div className={`${classes.Banner} ${className} ${dropClass} ${classes.ImageOnly}`} style={{ backgroundImage: `url(${banner.img})`, height, width }}>
                    <p className={classes.Text} style={{ color: banner?.colorText }}>{banner?.text?.[lang] ?? ""}</p>
                </div>
            </NavigateLink>
    )
};

export default BannerItem;